import { library } from '@fortawesome/fontawesome-svg-core'
import { faDiscord, faTwitter, faInstagram } from '@fortawesome/free-brands-svg-icons'
import {
    faBars, faTimes, faCoins, faPlus, faMinus, faSpinnerThird, faEmptySet, faPauseCircle, faHourglassHalf,
    faCheckCircle,
} from '@fortawesome/pro-solid-svg-icons'

library.add(faDiscord, faTwitter, faInstagram)
library.add(
    faBars, faTimes, faCoins, faPlus, faMinus, faSpinnerThird, faEmptySet, faPauseCircle, faHourglassHalf,
    faCheckCircle,
)
